/* nb-scratch-popup: turn-over-three-shakers welcome offer. Markup + rules in snippets/nb-scratch-popup.liquid. */
(function () {
  var root = document.getElementById('nbsc');
  if (!root) return;

  var KEY_DONE = 'nbsc_done';          // signed up: never show again
  var KEY_CLOSED = 'nbsc_closed_at';   // closed: hide for 24h (same as the Klaviyo form)
  var HIDE_MS = (parseFloat(root.getAttribute('data-hide-days')) || 1) * 24 * 60 * 60 * 1000;
  // Excluded URLs come from the section setting (one per line, * wildcards allowed, matched against the full URL).
  var DENY = (root.getAttribute('data-deny') || '').split(/[\n,]+/).map(function (s) { return s.replace(/\*/g, '').trim().toLowerCase(); }).filter(Boolean);

  var force = /[?&]nbsc=1\b/.test(location.search) || root.getAttribute('data-force') === 'true';

  function store(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } }
  function track(name) {
    try { if (window.clarity) window.clarity('event', name); } catch (e) {}
    try { (window.dataLayer = window.dataLayer || []).push({ event: name }); } catch (e) {}
  }

  // Klaviyo already knows this visitor (e.g. clicked through from an email): skip, like the Klaviyo form's "unidentified profiles" rule.
  function knownToKlaviyo() {
    var m = document.cookie.match(/(?:^|;\s*)__kla_id=([^;]+)/);
    if (!m) return false;
    try {
      var d = JSON.parse(atob(decodeURIComponent(m[1])));
      return !!(d.$exchange_id || d.$email);
    } catch (e) { return false; }
  }

  function eligible() {
    if (force) return true;
    var url = (location.host + location.pathname + location.search).toLowerCase();
    for (var i = 0; i < DENY.length; i++) if (url.indexOf(DENY[i]) !== -1) return false;
    if (store(KEY_DONE)) return false;
    var closed = parseInt(store(KEY_CLOSED) || '0', 10);
    if (closed && Date.now() - closed < HIDE_MS) return false;
    if (knownToKlaviyo()) return false;
    return true;
  }
  if (!eligible()) return;

  var panel = root.querySelector('.nbsc__panel');
  var cards = root.querySelectorAll('[data-nbsc-card]');
  var hint = root.querySelector('[data-nbsc-hint]');
  var form = root.querySelector('[data-nbsc-form]');
  var input = root.querySelector('#nbsc-email');
  var errorEl = root.querySelector('[data-nbsc-error]');
  var submitBtn = root.querySelector('[data-nbsc-submit]');
  var opened = false, flipped = 0, won = false, lastFocus = null;

  /* ---------- open / close ---------- */
  function open(reason) {
    if (opened) return;
    reason = typeof reason === 'string' ? reason : 'timer';
    var other = Array.prototype.some.call(document.querySelectorAll('[aria-modal="true"], dialog[open]'), function (el) {
      if (root.contains(el) || el.offsetParent === null || getComputedStyle(el).visibility === 'hidden') return false;
      var r = el.getBoundingClientRect(); // closed drawers sit off-screen
      return r.width > 0 && r.right > 0 && r.left < window.innerWidth && r.bottom > 0 && r.top < window.innerHeight;
    });
    if (other) { setTimeout(open, 8000); return; } // another popup is open: try again later
    opened = true;
    lastFocus = document.activeElement;
    root.hidden = false;
    root.classList.add('is-open');
    document.body.classList.add('nbsc-open');
    document.documentElement.style.overflow = 'hidden';
    requestAnimationFrame(function () {
      root.classList.add('is-visible');
      root.querySelector('.nbsc__close').focus({ preventScroll: true });
    });
    track('nbsc_open');
    // Diagnostics: why it opened and how many seconds after the page loaded (visible as tags on Clarity recordings).
    track('nbsc_open_' + reason);
    try { if (window.clarity) window.clarity('set', 'nbsc_open_after_s', String(Math.round(performance.now() / 1000))); } catch (e) {}
  }

  function close() {
    root.classList.remove('is-visible');
    document.body.classList.remove('nbsc-open');
    document.documentElement.style.overflow = '';
    if (!root.classList.contains('is-done')) { store(KEY_CLOSED, String(Date.now())); track('nbsc_close'); }
    setTimeout(function () { root.classList.remove('is-open'); root.hidden = true; }, 350);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    removeTriggers();
  }

  root.addEventListener('click', function (e) { if (e.target.closest('[data-nbsc-close]')) close(); });
  document.addEventListener('keydown', function (e) {
    if (!root.classList.contains('is-open')) return;
    if (e.key === 'Escape') close();
    if (e.key === 'Tab') { // keep focus inside the popup
      var f = Array.prototype.filter.call(root.querySelectorAll('button, a[href], input'), function (el) { return el.offsetParent !== null && !el.disabled; });
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    }
  });

  /* ---------- triggers: 12s delay or exit intent (desktop) ---------- */
  var timer = null, exitArmedAt = 0, mouseWasInside = false;
  // Exit intent only counts once the visitor has been here a few seconds AND has moved the mouse inside the page.
  // Otherwise moving up to the address bar right after a page loads opens it instantly.
  function onMove(e) { if (e.clientY > 40) mouseWasInside = true; }
  function onExit(e) { if (!e.relatedTarget && e.clientY <= 0 && mouseWasInside && Date.now() >= exitArmedAt) open('exit'); }
  function removeTriggers() { clearTimeout(timer); document.removeEventListener('mouseout', onExit); document.removeEventListener('mousemove', onMove); }
  function arm() {
    var delay = (parseInt(root.getAttribute('data-delay'), 10) || 12) * 1000;
    timer = setTimeout(open, delay);
    if (root.getAttribute('data-exit') === 'true' && window.matchMedia('(pointer: fine)').matches) {
      exitArmedAt = Date.now() + Math.min(delay, 4000);
      document.addEventListener('mousemove', onMove);
      document.addEventListener('mouseout', onExit);
    }
  }
  // Leaving the page while it is open counts as closing it, so it doesn't reappear on the very next page.
  window.addEventListener('pagehide', function () {
    if (root.classList.contains('is-open') && !root.classList.contains('is-done')) store(KEY_CLOSED, String(Date.now()));
  });
  // iOS Safari restores the previous page from memory on "back", popup and all. Close it if it was already counted as closed.
  window.addEventListener('pageshow', function (e) {
    if (e.persisted && root.classList.contains('is-open') && !root.classList.contains('is-done') && store(KEY_CLOSED)) close();
  });
  // Country rule: Shopify reports the visitor's detected country from their connection. Fails open (shows) if the check errors.
  var countries = (root.getAttribute('data-countries') || '').split(',').map(function (c) { return c.trim().toUpperCase(); }).filter(Boolean);
  if (force) {
    open('forced');
  } else if (!countries.length) {
    arm();
  } else {
    fetch('/browsing_context_suggestions.json', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var cc = d && d.detected_values && d.detected_values.country && d.detected_values.country.handle;
        if (!cc || countries.indexOf(String(cc).toUpperCase()) !== -1) arm(); else track('nbsc_skip_country');
      })
      .catch(arm);
  }

  /* ---------- four shakers, match three (like IM8) ---------- */
  var MATCH = parseInt(root.getAttribute('data-match'), 10) || 3;
  Array.prototype.forEach.call(cards, function (card, i) {
    card.addEventListener('click', function () {
      if (card.classList.contains('is-flipped') || won) return;
      card.classList.add('is-flipped');
      card.setAttribute('aria-label', 'Card ' + (i + 1) + ': 40% off');
      flipped++;
      if (flipped === 1) track('nbsc_flip_start');
      var left = MATCH - flipped;
      if (left > 0) {
        hint.textContent = (root.getAttribute('data-hint-more') || '{n} more to match.').replace('{n}', left);
      } else {
        hint.textContent = root.getAttribute('data-hint-win') || 'Three of a kind.';
        Array.prototype.forEach.call(cards, function (c) { if (!c.classList.contains('is-flipped')) { c.classList.add('is-locked'); c.disabled = true; } });
        setTimeout(win, 900);
      }
    });
  });

  function win() {
    if (won) return;
    won = true;
    root.classList.add('is-won');
    panel.scrollTop = 0;
    track('nbsc_win');
    if (window.matchMedia('(pointer: fine)').matches) setTimeout(function () { input.focus({ preventScroll: true }); }, 350);
  }

  /* ---------- sign-up to Klaviyo list ---------- */
  function showError(msg) { errorEl.textContent = msg; errorEl.classList.toggle('is-shown', !!msg); }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var email = (input.value || '').trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { showError('Please enter a valid email address.'); input.focus(); return; }
    showError('');
    submitBtn.disabled = true; submitBtn.textContent = 'Activating…';

    var body = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Shaker game popup',
          profile: { data: { type: 'profile', attributes: { email: email } } }
        },
        relationships: { list: { data: { type: 'list', id: root.getAttribute('data-list') } } }
      }
    };

    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + root.getAttribute('data-company'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', 'revision': '2024-10-15' },
      body: JSON.stringify(body)
    }).then(function (res) {
      if (!res.ok) throw new Error('Klaviyo ' + res.status);
      store(KEY_DONE, '1');
      try { if (window.klaviyo && window.klaviyo.identify) window.klaviyo.identify({ email: email }); } catch (err) {}
      root.classList.add('is-done');
      panel.scrollTop = 0;
      track('nbsc_submit');
      setTimeout(function () { var a = root.querySelector('[data-nbsc-done]'); if (a) a.focus({ preventScroll: true }); }, 50);
    }).catch(function () {
      submitBtn.disabled = false; submitBtn.textContent = submitBtn.getAttribute('data-label') || 'Continue';
      showError('Something went wrong. Please try again.');
    });
  });

  var doneBtn = root.querySelector('[data-nbsc-done]');
  if (doneBtn) doneBtn.addEventListener('click', function () { track('nbsc_done_close'); });
})();
